<div class="froala-editor--wrapper" [froalaEditor]="options" [froalaModel]="model" (froalaModelChange)="onFroalaModelChange($event)"></div>
